export default "__VITE_ASSET__DIP$fw_c__"